import { useTemplateCreateChecklist } from '@infield/features/template/hooks';
import { useCurrentUserContext } from '@infield/providers/current-user-provider/current-user-provider';
import { createContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSearchQuery } from '../../hooks/use-template-list/use-search-query';
import { useTemplateSelection } from '../../hooks/use-template-list/use-template-selection';

export type TemplateListMobileContextInterface = {
  useNavigate: typeof useNavigate;
  useTemplateCreateChecklist: typeof useTemplateCreateChecklist;
  useSearchQuery: typeof useSearchQuery;
  useTemplateSelection: typeof useTemplateSelection;
  useCurrentUserContext: () => ReturnType<typeof useCurrentUserContext>;
};

const defaultValues: TemplateListMobileContextInterface = {
  useNavigate,
  useTemplateCreateChecklist,
  useSearchQuery,
  useTemplateSelection,
  useCurrentUserContext: () => useCurrentUserContext(),
};

export const TemplateListMobileContext =
  createContext<TemplateListMobileContextInterface>(defaultValues);
